import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Grow,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { memo, useCallback, useEffect, useState } from "react";
import {
  DateFormatter,
  ScrollheightForScreenSize,
  formatIndianNumber,
} from "./DateFormatter";
import Div from "@jumbo/shared/Div";
import {
  BiEdit,
  BiLeftArrowAlt,
  BiRightArrowAlt,
  BiSolidFilePdf,
} from "react-icons/bi";
import Skeleton from "@mui/material/Skeleton";
import { RiArrowDownSFill, RiFileExcel2Fill } from "react-icons/ri";
import {
  MdAdd,
  MdArrowDropDown,
  MdCall,
  MdCheck,
  MdDelete,
  MdKeyboardDoubleArrowRight,
  MdPlayArrow,
} from "react-icons/md";
import useResponsive from "app/pages/useResponsive";
import loadingDotsImage from "../../../assets/images/loadingDots.gif";
import companyImage from "../../../assets/images/HRMFarmlogo.png";
// import companyImage from "../../../assets/images/Felix.png";

import bankImage from "../../../assets/images/Bank.png";
import cashImage from "../../../assets/images/Cash.png";
import NoDataImage from "../../../assets/images/NoData.jpg";
import NoPermissionsImage from "../../../assets/images/403-forbidden.png";
import axios from "axios";
import { styled, darken, useMediaQuery, alpha } from "@mui/system";
import convertRupeesIntoWords from "convert-rupees-into-words";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import {
  BASE_URL,
  Tenantname,
  TENANTS_WITHOUT_REQUIRED_FIELD,
} from "app/services/auth-services";
import JumboContentLayoutMain from "@jumbo/components/JumboContentLayout/JumboContentLayoutMain";
import Span from "@jumbo/shared/Span";
import PropTypes from "prop-types";
import Draggable from "react-draggable";
import { BsFilterLeft } from "react-icons/bs";
import { IoMdClose, IoMdPrint, IoMdSend } from "react-icons/io";
import { GrFormView } from "react-icons/gr";
import { VscPreview } from "react-icons/vsc";
import { avatarColors, AvatarFont, Colors } from "./ERPstyle";
import { generateHRApprovalMail } from "app/utils/documentUtils";

export const darkColors = [
  "#8e44ad",
  "#e91e63",
  "#e67d21",
  "#2196f3",
  "#198754",
  "#6610f2",
  "#dc3545",
  "#0dcaf0",
  "#20c997",
  "#6673FC",
];

export const lightColors = [
  "#3686FF",
  "#7C47F7",
  "#8E6AC1",
  "#EB5F9F",
  "#FF6B77",
  "#FFA14E",
  "#2BB673",
  "#31D9FF",
  "#45E8B6",
  "#7785FF",
];

export const ExcelColors = {
  bgcolor: "#EAECEC",
  color: "#31D9FF",
};

export const DataCountStyle = {
  fontSize: "18px !important",
  color: "#000000",
  // color: "#fff",
  // backgroundColor: "#017890",
  borderRadius: "11px",
  padding: "1px 7px",
  marginLeft: "5px",
};

export const TableDataCount = ({ count }) => {
  return (
    <Span sx={[DataCountStyle]}>
      <Counter maximum={count || 0} />
    </Span>
  );
};

export const formatNumber = (number) => {
  if (number === 0) return "0.00";

  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export const NumberandFloatRegex = /^-?\d*\.?\d*$/;

// FirstLetterCaps
export const FirstLetterCaps = (value = "") => {
  return value?.charAt(0)?.toUpperCase() + value?.slice(1);
};

export const formatKey = (key = "") => {
  console.log("formatKey");
  return key
    ?.replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char?.toUpperCase());
};

export const AllImages = [
  {
    name: "lodingImg",
    source: loadingDotsImage,
  },
  {
    name: "companyImag",
    source: companyImage,
  },
  {
    name: "noDataImg",
    source: NoDataImage,
  },
  {
    name: "noPermissionsImg",
    source: NoPermissionsImage,
  },
  {
    name: "bankImage",
    source: bankImage,
  },
  {
    name: "cashImage",
    source: cashImage,
  },
];

export const CommonOverviewSkeleton = memo(() => {
  return (
    <List
      disablePadding
      sx={{
        mr: 2,
        pb: 2,
      }}
    >
      {[...Array(10).keys()].map((index) => (
        <ListItem sx={{ p: 0.25 }} key={index}>
          <ListItemText primary={<Skeleton width={"100%"} height={40} />} />
        </ListItem>
      ))}
    </List>
  );
});

export const findChangedKeys = (
  previousArray = [],
  newArray = [],
  name = "",
  withKeysOnly = [
    "accountName",
    "GLaccount_Id",
    "Particulars",
    "debit",
    "credit",
  ],
) => {
  console.log("previousArray", previousArray, newArray);
  console.log("withKeysOnly", withKeysOnly);

  let ChangedValueKey = [];

  const numLinesAdded = newArray?.length - previousArray?.length; // 10 -9 or 9-10

  const numLinesDeleted = previousArray?.length - newArray?.length; // 20-10 or 15-20

  newArray?.forEach((newObj, index) => {
    let ChangedKeys = [];
    let PrevObj = previousArray[index];

    if (PrevObj) {
      Object.keys(newObj)?.forEach((newProp) => {
        if (
          withKeysOnly?.includes(newProp) &&
          newObj[newProp] !== PrevObj[newProp]
        ) {
          // checking without property name provied and check both are not wuals.
          ChangedKeys?.push(formatKey(newProp));
        }
      });
    } else {
      ChangedKeys = Object.keys(newObj)
        ?.filter((item) => withKeysOnly.includes(item))
        ?.map((item) => formatKey(item));
    }

    if (ChangedKeys?.length > 0) {
      ChangedValueKey?.push({
        keys: [`${name} Line ${index + 1}`, ...ChangedKeys],
      });
    }
  });

  if (numLinesAdded > 0) {
    // 9, 9 < 10 ,i++
    for (let i = previousArray.length; i < newArray.length; i++) {
      ChangedValueKey?.push({ keys: [`${name} Line ${i + 1}`, "Added"] });
    }
  }

  if (numLinesDeleted > 0) {
    //      10, 10 < 20 ,i++
    for (let i = newArray.length; i < previousArray.length; i++) {
      ChangedValueKey?.push({ keys: [`${name} Line ${i + 1}`, "Removed"] });
    }
  }

  return ChangedValueKey;
};

export const HeaderLength = (header = []) => {
  let value = header?.filter((item) => item?.boolean)?.length;
  if (value <= 3) {
    return 30;
  } else if (value <= 4) {
    return 20;
  } else {
    return 17;
  }
};

// Report Table Headings
export const ReportTableHead = memo(({ heads = [], colSpans = 2 }) => {
  console.log("heads", heads);
  return (
    <TableRow sx={{ fontWeight: 600 }}>
      {heads?.map((head, index) => (
        <TableCell
          colSpan={colSpans}
          key={index + 99}
          style={{
            fontWeight: 600,
            textAlign: head?.align === "right" ? "right" : "left",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <b>{head?.label}</b>
        </TableCell>
      ))}
    </TableRow>
  );
});

export const FormatFileName = (filename = "file.png", lengthNumber = 10) => {
  console.log("Formatting file", filename);
  const dotIndex = filename.lastIndexOf(".");
  const namePart = filename.substring(0, dotIndex);
  const extPart = filename.substring(dotIndex);
  const formattedName =
    namePart.length > lengthNumber
      ? namePart.substring(0, lengthNumber)
      : namePart;
  return `${formattedName}${extPart}`;
};

export const CustomTooltip = memo(
  ({ value = "", realvalue = "", char = 10 }) => {
    const displayValue = realvalue || value;

    const tooltipTitle =
      displayValue?.length > char ? FirstLetterCaps(displayValue) : "";

    const truncatedValue =
      value?.length > char ? value.slice(0, char) + "..." : value;

    return (
      <Tooltip title={tooltipTitle} placement="right-end">
        <span>{truncatedValue ? FirstLetterCaps(truncatedValue) : "-"}</span>
      </Tooltip>
    );
  },
);

export const CustomScrollBar = memo(
  ({
    stateValue = true,
    childrens = <></>,
    fromDate = "",
    toDate = "",
    formName = "",
    userDetails = {},
    companyLogo = companyImage,
    TotalAmount = 0,
    Notes = "",
    ImageState = {
      state: false,
      name: "",
    },
    LeftContent = [],
    scrollHeight,
    scrollPercent = 1.3,
  }) => {
    const [companyData, setCompanyData] = useState({});
    let [screenHeight, screenWidth] = ScrollheightForScreenSize();
    const CurrentDate = new Date().toJSON().slice(0, 10);

    let isMobile = useResponsive("down", "md");

    const toWordsCustom = (num) => {
      if (num === 0) return "ZERO Only";

      const words = convertRupeesIntoWords(num);
      return `${words.toUpperCase()}`;
    };

    // change the amount to text
    const amountWords = toWordsCustom(Number(TotalAmount));

    const companyId = parseInt(localStorage.getItem("OrganizationId"));
    const companyDetails = useCallback(async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/Felix/CompanyCRUD/?id=${companyId}`,
        );
        setCompanyData(response?.data);
      } catch (error) {
        console.log(error);
      }
    }, [companyId]);

    useEffect(() => {
      companyDetails();
    }, [companyId]);

    if (stateValue) {
      return (
        // <JumboScrollbar
        //     autoHeight={true}
        //     autoHideTimeout={4000}
        //     autoHeightMin={Boolean(scrollHeight) ? scrollHeight : isMobile ? 400 : Math.round(screenHeight / scrollPercent)}
        //     autoHide={true}
        //     hideTracksWhenNotNeeded
        // >
        //     {childrens}
        // </JumboScrollbar>
        <>{childrens}</>
      );
    } else {
      return (
        <>
          <Div
            className="row"
            sx={{
              px: 2,
              mt: { xs: 0, md: 2 },
              display: { xs: "flex", md: "flex" },
            }}
          >
            <Div className="col-sm-12 col-md-4">
              <img
                // src={companyLogo}
                src={`${BASE_URL}${companyData?.CompanyLogo}`}
                alt="Foyer Logo"
                width={100}
                height={50}
              />
              <Typography variant="h4" sx={{ fontWeight: 500 }}>
                {/* Foyertech INDIA PRIVATE LIMITED */}
                {companyData?.Company_Name}
              </Typography>
            </Div>
            <Div className="col-sm-12 col-md-5" sx={{ textAlign: "center" }}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "18px !important",
                  display: "inline-block",
                  borderBottom: "1px solid gray",
                }}
              >
                {formName}
              </Typography>
            </Div>
            <Div className="col-sm-12 col-md-3" sx={{ textAlign: "right" }}>
              {Boolean(ImageState?.state) && (
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "22px !important",
                  }}
                >
                  {ImageState?.name == "CASH" ? (
                    <img
                      src={cashImage}
                      alt="Cash Logo"
                      width={120}
                      height={65}
                    />
                  ) : (
                    <img
                      src={bankImage}
                      alt="Bank Logo"
                      width={120}
                      height={65}
                    />
                  )}
                </Typography>
              )}
            </Div>
          </Div>

          {Boolean(fromDate) && Boolean(toDate) && (
            <Div sx={{ display: "flex", fontSize: "14px", mt: 3, px: 2 }}>
              <Div item className="col-4" sx={{ textAlign: "left" }}>
                <Typography variant="h4">
                  {" "}
                  Date :{" "}
                  <DateFormatter
                    date={CurrentDate}
                    dateFormat={userDetails?.DateFormat}
                  />
                </Typography>
              </Div>
              {Boolean(fromDate) && (
                <Div item className="col-4" sx={{ textAlign: "left" }}>
                  <Typography variant="h4">
                    {" "}
                    From :{" "}
                    <DateFormatter
                      date={fromDate}
                      dateFormat={userDetails?.DateFormat}
                    />
                  </Typography>
                </Div>
              )}
              {Boolean(toDate) && (
                <Div item className="col-4" sx={{ textAlign: "left" }}>
                  <Typography variant="h4">
                    {" "}
                    To :{" "}
                    <DateFormatter
                      date={toDate}
                      dateFormat={userDetails?.DateFormat}
                    />
                  </Typography>
                </Div>
              )}
            </Div>
          )}

          {LeftContent?.length > 0 && (
            <Grid
              columns={12}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                fontSize: "14px",
                mt: 3,
                px: 2,
              }}
            >
              {LeftContent?.map((item, index) => (
                <Div
                  key={index}
                  className="col-6"
                  sx={{ textAlign: index % 2 == 0 ? "left" : "right" }}
                >
                  <Typography variant="h4">
                    {item?.name} : &nbsp; {item?.value}
                  </Typography>
                </Div>
              ))}
            </Grid>
          )}

          <Div sx={{ px: 2, mt: 2 }}>{childrens}</Div>

          <Grid
            columns={12}
            sx={{
              px: 2,
              mt: 15,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Div className="row col-8">
              <Div className="col-2">
                {Boolean(Notes) && <Typography variant="h4">Notes</Typography>}
                {Boolean(TotalAmount) && (
                  <Typography variant="h4">Rupees</Typography>
                )}
              </Div>
              <Div className="col-10">
                {Boolean(Notes) && (
                  <Typography variant="h4">
                    : &nbsp; {Boolean(Notes) ? FirstLetterCaps(Notes) : "-"}
                  </Typography>
                )}
                {Boolean(TotalAmount) && (
                  <Typography variant="h4">
                    : &nbsp; {FirstLetterCaps(amountWords?.toUpperCase())} Only,
                  </Typography>
                )}
              </Div>
            </Div>
            {Boolean(TotalAmount) && (
              <Div className="row col-4">
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "15px !important",
                    textAlign: "right",
                  }}
                ></Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "16px !important",
                    textAlign: "right",
                  }}
                >
                  Signature
                </Typography>
              </Div>
            )}
          </Grid>
        </>
      );
    }
  },
);

export const CustomTableFooter = memo(
  ({
    dataLists,
    colValue = 1,
    loadingStatus = false,
    credit = "credit",
    debit = "debit",
    printPageState = false,
  }) => {
    let isMobile = useResponsive("down", "md");

    return (
      <>
        {!Boolean(loadingStatus) && dataLists?.length > 0 && (
          <TableRow
            sx={{
              bgcolor: "#EFEFEF !important",
              position: Boolean(printPageState) ? "none" : "sticky",
              bottom: isMobile ? "0px" : "-2px",
            }}
          >
            {!isMobile && (
              <>
                <TableCell colSpan={colValue - 1}></TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    fontSize: "16px",
                    fontWeight: 900,
                    minHeight: "55px !important",
                  }}
                >
                  Total
                </TableCell>
              </>
            )}

            <TableCell
              data-title={`Total ${FirstLetterCaps(
                credit == "TotalCredit" ? " Credit" : credit,
              )}`}
              sx={{ textAlign: "right", fontSize: "16px", fontWeight: 500 }}
            >
              <Div sx={{ display: "flex", justifyContent: "right" }}>
                <span
                  style={{
                    backgroundColor: "#FFEBAD",
                    color: "#966F03",
                    fontWeight: 900,
                    padding: isMobile ? "5px" : "5px 8px",
                    borderRadius: "10px",
                  }}
                >
                  {formatIndianNumber(
                    dataLists.reduce(
                      (acc, cur) =>
                        acc + parseFloat(Math.abs(cur?.[debit])) || 0,
                      0,
                    ),
                  )}
                </span>
              </Div>
            </TableCell>

            <TableCell
              data-title={`Total ${FirstLetterCaps(
                debit == "TotalDebit" ? " Debit" : debit,
              )}`}
              sx={{ textAlign: "right", fontSize: "16px", fontWeight: 500 }}
            >
              <Div sx={{ display: "flex", justifyContent: "right" }}>
                <span
                  style={{
                    backgroundColor: "#B3FFAE",
                    color: "#057B1B",
                    fontWeight: 900,
                    padding: isMobile ? "5px" : "5px 8px",
                    borderRadius: "10px",
                  }}
                >
                  {formatIndianNumber(
                    dataLists.reduce(
                      (acc, cur) =>
                        acc + parseFloat(Math.abs(cur?.[credit])) || 0,
                      0,
                    ),
                  )}
                </span>
              </Div>
            </TableCell>
          </TableRow>
        )}
      </>
    );
  },
);

const useCounter = (minimum, maximum, duration) => {
  const [count, setCount] = useState(minimum);

  useEffect(() => {
    if (maximum <= minimum) {
      setCount(maximum); // If maximum is less than or equal to minimum, set count to maximum directly
      return;
    }

    const totalSteps = maximum - minimum;
    const stepTime = duration / totalSteps;
    let currentStep = 0;
    const startTime = performance.now();

    const updateCount = (currentTime) => {
      const elapsed = currentTime - startTime;
      currentStep = Math.min(totalSteps, Math.floor(elapsed / stepTime));
      setCount(minimum + currentStep);
      if (currentStep < totalSteps) {
        requestAnimationFrame(updateCount);
      }
    };

    setCount(minimum);
    requestAnimationFrame(updateCount);

    return () => setCount(minimum); // Clean up function
  }, [minimum, maximum, duration]);

  return count;
};

export const Counter = memo(({ minimum = 0, maximum, duration = 3 }) => {
  const durations = duration > 2 ? 1 : duration == 0 ? 0 : 1.3;
  const count = useCounter(minimum, maximum, parseFloat(durations) * 1000);
  return <>{count}</>;
});

export const CustomExcelOverview = ({
  headersTable = [],
  childerns = <></>,
  fromDate,
  toDate,
  FormName = "",
  cols = [2, 3, 2],
  dateCols = [2, 3, 3, 2],
  id = "table-to-xlsx",
}) => {
  const token = localStorage.getItem("accesstoken");

  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  const [companyDetails, setComapanyDetails] = useState({});
  const companyId = parseInt(localStorage.getItem("OrganizationId"));
  useEffect(async () => {
    try {
      await axios
        .get(`${BASE_URL}/Felix/CompanyCRUD/?id=${companyId}`, header)
        .then((res) => {
          setComapanyDetails(res?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }, [companyId]);

  return (
    <Table
      id={id}
      bordered
      className="table table-bordered"
      sx={{ display: "none" }}
    >
      <TableHead className="table-head">
        <TableRow>
          <TableCell colSpan={1} style={{ textAlign: "left" }}></TableCell>
          <TableCell colSpan={cols[0] - 1} style={{ textAlign: "left" }}>
            <img
              src={`${BASE_URL}${companyDetails?.CompanyLogo}`}
              alt={companyDetails?.Company_Name}
              width={120}
              height={"5%"}
            />
          </TableCell>
          <TableCell colSpan={cols[1]} style={{ textAlign: "center" }}>
            <Typography variant="h3">{FormName}</Typography>
          </TableCell>
          <TableCell colSpan={cols[2]}></TableCell>
        </TableRow>

        {Boolean(fromDate && toDate) && (
          <TableRow>
            <TableCell colSpan={dateCols[0]}></TableCell>
            <TableCell
              colSpan={dateCols[1]}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              From : <DateFormatter date={fromDate} />
            </TableCell>
            <TableCell
              colSpan={dateCols[2]}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              To : <DateFormatter date={toDate} />
            </TableCell>
            <TableCell colSpan={dateCols[3]}></TableCell>
          </TableRow>
        )}

        <TableRow>
          <TableCell colSpan={7}></TableCell>
        </TableRow>

        <ReportTableHead
          heads={headersTable}
          ActionMenus={{ cell: false, actionIcon: false }}
        />
      </TableHead>
      <TableBody>{childerns}</TableBody>
    </Table>
  );
};

export const CustomButton = ({
  onClick = null,
  sx = {},
  label = "No Label",
  Icon = "createIcon",
  bgColor = Colors?.Mblue,
  textColor = "white !important",
  type = "button",
  width = null,
  disabled = false,
  endIcon = false,
  loading = false,
}) => {
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <ButtonGroup
      aria-label="split button"
      onClick={onClick}
      disabled={disabled}
    >
      <Button
        sx={[
          matches && sx,
          {
            width: Boolean(width) ? width : matches ? "100px" : "60px",
            // height: "33px",
            // backgroundColor: bgColor,
            "&:hover": {
              backgroundColor: alpha(bgColor, 0.8),
              boxShadow: "none",
            },
            color: textColor,
          },
        ]}
        type={type}
        disabled={disabled}
        startIcon={
          !endIcon && matches && Boolean(Icon) ? CustomIcons[Icon] : ""
        }
        endIcon={endIcon && matches && Boolean(Icon) ? CustomIcons[Icon] : ""}
        onClick={onClick}
        variant="contained"
      >
        {loading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          FirstLetterCaps(label)
        )}
        {/* {FirstLetterCaps(label)} */}
      </Button>
    </ButtonGroup>
  );
};

export const PdfDownloadButton = memo(
  ({ setPrintPageState = false, conditions = false, stopAnimation = true }) => {
    return (
      <Button
        className={
          !Boolean(conditions) && Boolean(stopAnimation)
            ? "PDF-Excel-Button"
            : ""
        }
        sx={{
          minWidth: "110px !important",
          height: "34px !important",
          "&:hover": {
            bgcolor: "#017890 !important",
            color: "white !important",
          },
        }}
        variant={
          Boolean(conditions) && Boolean(stopAnimation)
            ? "contained"
            : "outlined"
        }
        startIcon={<BiSolidFilePdf size={22} />}
        onClick={() => setPrintPageState(true)}
        disabled={conditions}
      >
        PDF
      </Button>
    );
  },
);

export const ExcelDownloadButton = memo(
  ({ ExportToExcel = "", conditions = false, stopAnimation = true }) => {
    return (
      <Button
        className={`${
          !Boolean(conditions) && Boolean(stopAnimation)
            ? "PDF-Excel-Button ButtonHover"
            : "GrayExcelText"
        }`}
        sx={{
          position: "relative",
          minWidth: "110px !important",
          height: "34px !important",
          "&:hover": {
            bgcolor: "#3FD3A4 !important",
            color: "white !important",
          },
        }}
        variant={
          Boolean(conditions) && Boolean(stopAnimation)
            ? "contained"
            : "outlined"
        }
        color="success"
        startIcon={<RiFileExcel2Fill size={20} />}
        disabled={conditions}
      >
        Excel
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          table="table-to-xlsx"
          filename={`${ExportToExcel}`}
          sheet="Sheet1"
          buttonText=""
          className="ReactHTMLTableToExcel"
        />
      </Button>
    );
  },
);

export const CustomSkeleton = memo(({ rowCount = 10, headCount = 8 }) => {
  return (
    <>
      {Array(rowCount)
        .fill()
        .map((item, index) => (
          <TableRow key={index + 1}>
            {Array(headCount)
              .fill()
              .map((data) => (
                <TableCell>
                  <Skeleton height={30} />
                </TableCell>
              ))}
          </TableRow>
        ))}
    </>
  );
});

export const OverviewListSkeleton = memo(({ listCount = 10 }) => {
  return (
    <>
      <Div className="row mt-2" sx={{ display: { xs: "none", md: "flex" } }}>
        <Div className="col col-sm-2 col-md-3">
          {Array(listCount)
            .fill()
            .map((item, index) => (
              <Skeleton height={25} />
            ))}
        </Div>
        <Div className="col col-sm-4 col-md-5">
          {Array(listCount)
            .fill()
            .map((item, index) => (
              <Skeleton height={25} />
            ))}
        </Div>
      </Div>
    </>
  );
});

export const TreeIconsLevel1 = memo(
  ({ value = false, margins = "-0 8px 0px 0px" }) => {
    return (
      <IconButton size="small" sx={{ margin: margins }}>
        {Boolean(value) ? (
          <RiArrowDownSFill
            size={18}
            style={{
              borderRadius: "3px",
              border: "1px solid #017890",
              color: "#017890",
            }}
          />
        ) : (
          <MdPlayArrow
            size={18}
            style={{
              borderRadius: "3px",
              border: "1px solid #D6D8D9",
              color: "#898989",
            }}
          />
        )}
      </IconButton>
    );
  },
);

export const getGeocode = async (address) => {
  // Encode the address to be URL-safe
  const url = `https://geocode.xyz/${encodeURIComponent(address)}?json=1`;

  try {
    const response = await axios.get(url);
    const data = response.data;

    if (data && data.latt && data.longt) {
      const latitude = data.latt;
      const longitude = data.longt;
      console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
      return { latitude, longitude };
    } else {
      console.error("No geocoding results found");
    }
  } catch (error) {
    console.error("Error fetching geocoding data:", error);
  }
};

export const GroupByOptions = (
  filteredAccounts = [],
  keyName = "Account_Name",
) => {
  return filteredAccounts.map((option) => {
    const firstLetter = option[keyName][0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });
};

export const ListHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === "light"
      ? "#EFEFEF"
      : darken(theme.palette.primary.main, 0.8),
}));

export const ListItems = styled("ul")({
  padding: 0,
});

export const CustomScrollbarBox = styled(Box, {
  shouldForwardProp: (prop) =>
    !["scrollWidth", "scrollHeight", "overflowX", "overflowY"].includes(prop),
})(
  ({
    scrollWidth = "100%",
    scrollHeight = "100%",
    overflowX = false,
    overflowY = true,
  }) => ({
    width: scrollWidth,
    height: scrollHeight,
    overflowX: overflowX ? "auto" : "hidden",
    overflowY: overflowY ? "auto" : "hidden",
    position: "relative",

    // Scrollbar styling (Webkit browsers)
    "&::-webkit-scrollbar": {
      width: overflowY ? "6px" : "0px",
      height: overflowX ? "6px" : "0px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#CFCFCF",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#AFAFAF",
    },

    // Firefox scrollbar
    scrollbarWidth: overflowY ? "thin" : "none",
    scrollbarColor: "#CFCFCF #f1f1f1",
  }),
);

export const ERPCustomLoader = () => {
  return (
    <JumboContentLayoutMain>
      <Div
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
        }}
      >
        <CircularProgress />
      </Div>
    </JumboContentLayoutMain>
  );
};

export const errorFilter = (err, transactionSeriesType) => {
  let errors = {};

  if (err && typeof err === "object" && !Array.isArray(err)) {
    Object.keys(err).forEach((field) => {
      if (typeof err[field] === "string") {
        if (!err[field].trim()) {
          errors[field] = `${field} is required.`; // Customize your error message
        }
      } else if (typeof err[field] === "object") {
        errors[field] = errorFilter(err[field], transactionSeriesType); // Recursively process nested errors
      }
    });
  }
  return errors;
};

export const errorRequired = (err) => {
  const formatString = (str) => {
    str = str.replace(/_/g, " ");
    str = str.replace(/([a-z])([A-Z])/g, "$1 $2");
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const isValidPhone = (phone) => {
    const phoneRegex = /^\d{10}$/; // Ensures exactly 10 digits
    return phoneRegex.test(phone);
  };
  let error = {};
  if (err && typeof err === "object" && !Array.isArray(err)) {
    Object.keys(err)?.forEach((field) => {
      if (typeof err[field] === "string" && !Boolean(err[field].trim())) {
        error[field] = `${formatString(field)} is required.`;
      } else if (typeof err[field] === "number" && !Boolean(err[field])) {
        error[field] = `${formatString(field)} is required.`;
      } else if (field === "Mail" && !isValidEmail(err[field])) {
        error[field] = `${formatString(field)} must be a valid email address.`;
      } else if (field === "Phone" && !isValidPhone(err[field])) {
        error[field] = `${formatString(field)} must be exactly 10 digits.`;
      }
      if (field === "selectedCountry1" && !Boolean(err[field])) {
        error[field] = "Country is required.";
      }
      if (field === "selectedState1" && !Boolean(err[field])) {
        error[field] = "State is required.";
      }
      if (field === "selectedCity1" && !Boolean(err[field])) {
        error[field] = "City is required.";
      }
    });
  }
  console.log("errorRequired", error);
  return error;
};

export const NumericTextField = ({
  value = "",
  onChange,
  name,
  id,
  placeholder,
  variant = "outlined",
  disabled = false,
  sx = { minWidth: "100px" },
  ...rest
}) => {
  return (
    <TextField
      // type="number"
      type="text"
      className="col-md-12 input-box"
      name={name}
      id={id}
      value={value}
      // onChange={onChange}
      onChange={(e) => {
        const val = e.target.value;
        // Allow only digits and one dot
        if (/^\d*\.?\d*$/.test(val) || val === "") {
          onChange(e);
        }
      }}
      variant={variant}
      placeholder={placeholder}
      disabled={disabled}
      inputProps={{
        inputMode: "decimal",
        // pattern: "[0-9]*\\.?[0-9]*",
        pattern: "\\d*\\.?\\d+",
        min: 0,
        style: {
          MozAppearance: "textfield",
          WebkitAppearance: "none",
          appearance: "none",
          overflow: "hidden",
        },
        onWheel: (e) => e.preventDefault(),
        onKeyDown: (e) => {
          // Prevent default action for arrow keys to avoid scrolling
          if (
            e.key === "ArrowUp" ||
            e.key === "ArrowDown" ||
            e.key === "-" ||
            e.key === "Minus" ||
            e.key === "+" ||
            e.key === "Plus"
          ) {
            e.preventDefault();
          }
        },
        onPaste: (e) => {
          const paste = e.clipboardData.getData("text");
          console.log("paste", paste);
          if (!/^\d*\.?\d*$/.test(paste)) {
            e.preventDefault();
          } else if (paste.includes("-")) {
            e.preventDefault();
          } else if (paste.includes("+")) {
            e.preventDefault();
          }
        },
      }}
      autoComplete="off"
      sx={{
        ...sx,
        textAlign: "right",
        "& input[type=number]": {
          MozAppearance: "textfield",
          WebkitAppearance: "none",
          appearance: "none",
          overflow: "hidden",
        },
        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
          {
            WebkitAppearance: "none",
            margin: 0,
          },
      }}
      {...rest} // Spread the rest of the props
    />
  );
};

export const allowedFileTypes = [
  "application/pdf", // PDF
  "text/plain", // Text files
  "text/csv", // CSV
  "application/vnd.ms-excel", // Older Excel
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // Newer Excel
];

export const ErpOverviewLoader = () => {
  return (
    <Div sx={{ position: "absolute", top: "50%", left: "50%", zIndex: 999 }}>
      <CircularProgress />
    </Div>
  );
};

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      sx
    >
      <Paper {...props} />
    </Draggable>
  );
}

export const Dragabledialog = ({
  open,
  onClose,
  children,
  dragable = true,
  maxWidth,
}) => {
  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth
      open={open}
      onClose={onClose}
      PaperComponent={dragable ? PaperComponent : ""}
      aria-labelledby="draggable-dialog-title"
      sx={{ borderRadius: "10px !important" }}
    >
      {children}
    </Dialog>
  );
};

export const NoRecordsPage = ({
  title = "",
  minWidth = "100px",
  minHeight = "100px",
  width = "30%",
  height = "30%",
}) => (
  <>
    <Div sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Div>
        <Div sx={{ display: "flex", justifyContent: "center" }}>
          <img
            style={{
              minWidth: minWidth,
              minHeight: minHeight,
              width: width,
              height: height,
            }}
            src={require("../../../assets/images/No_record.png")}
            alt="Not Found"
          />
        </Div>
        <Div>
          <Typography sx={[{ textAlign: "center", fontSize: "12px" }]}>
            No {title} record.
          </Typography>
        </Div>
      </Div>
    </Div>
  </>
);

const defaultContent =
  "Felix found that some modification has been made. By cancelling the modification will not be saved";
export const DialogBox = ({
  onClickYes,
  disabled = false,
  onClickNo,
  open,
  Title = "Warning",
  Content = defaultContent,
  Subcontent = "",
  Icon1 = "checkIcon",
  Icon2 = "closeIcon",
  Label1 = "Yes",
  Label2 = "No",
  BtnWidth1 = "70px",
  BtnWidth2 = "70px",
  Buttons = true,
  maxWidth = "",
  fullWidth = false,
}) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      xs={12}
    >
      <DialogTitle
        sx={{
          display: "flex",
          height: "38px !important",
          margin: "0px !important",
        }}
      >
        <Typography
          id="Typography-root"
          sx={{
            fontSize: "14px !important",
            fontWeight: "600 !important",
            transform: "translateX(-10px)",
          }}
        >
          {Title}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          width: !Boolean(maxWidth) ? "380px !important" : "100%",
          fontWeight: Title !== "Warning" ? 300 : 200,
          lineHeight: 2,
        }}
      >
        <Box
          sx={{
            minHeight: "60px",
            maxHeight: "100px",
            backgroundColor: "transparent !important",
          }}
        >
          <Typography sx={[{ mt: 1 }]}>{Content}</Typography>
          <Typography sx={[{ color: "#EA7135 !important", my: 2 }]}>
            {Subcontent}
          </Typography>
        </Box>

        {Buttons && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              // gap: "10px !important",
              // flexWrap: "wrap",
              width: "100% !important",
            }}
          >
            <Div
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px !important",
              }}
            >
              {Boolean(Label1) && (
                <CustomButton
                  disabled={disabled}
                  width={BtnWidth1}
                  label={Label1}
                  Icon={Icon1}
                  onClick={onClickYes}
                  sx={{ mr: 1, height: "28px !important" }}
                />
              )}
              {Boolean(Label2) && (
                <CustomButton
                  disabled={disabled}
                  width={BtnWidth2}
                  Icon={Icon2}
                  label={Label2}
                  onClick={onClickNo}
                  sx={{ height: "28px !important" }}
                />
              )}
            </Div>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export const CustomIcons = {
  createIcon: <MdAdd style={{ fontSize: 18, fontWeight: 900 }} />,
  deleteIcon: <MdDelete style={{ fontSize: 18, fontWeight: 900 }} />,
  // uploadIcon: (
  //     <IoCloudUploadOutline style={{ fontSize: 18, fontWeight: 900 }} />
  // ),
  // downloadIcon: (
  //     <IoCloudDownloadOutline style={{ fontSize: 18, fontWeight: 900 }} />
  // ),
  EditIcon: <BiEdit style={{ fontSize: 18, fontWeight: 900 }} />,
  filterIcon: <BsFilterLeft style={{ fontSize: 18, fontWeight: 900 }} />,
  // saveIcon: <SaveIcon style={{ fontSize: 18, fontWeight: 900 }} />,
  sendIcon: <IoMdSend style={{ fontSize: 18, fontWeight: 900 }} />,
  // checkIcon: <IoCheckmark style={{ fontSize: 18, fontWeight: 900 }} />,
  nextIcon: <BiRightArrowAlt style={{ fontSize: 18, fontWeight: 900 }} />,
  backIcon: <BiLeftArrowAlt style={{ fontSize: 18, fontWeight: 900 }} />,
  moveIcon: (
    <MdKeyboardDoubleArrowRight style={{ fontSize: 18, fontWeight: 900 }} />
  ),
  checkIcon: <MdCheck style={{ fontSize: 18, fontWeight: 900 }} />,
  closeIcon: (
    <IoMdClose style={{ fontSize: { xs: 16, md: 23 }, fontWeight: 900 }} />
  ),
  viewIcon: (
    <GrFormView style={{ fontSize: { xs: 18, md: 23 }, fontWeight: 900 }} />
  ),
  downArrowIcon: (
    <MdArrowDropDown
      style={{ fontSize: { xs: 14, md: 23 }, fontWeight: 900 }}
    />
  ),
  PreviewIcon: <VscPreview style={{ fontSize: 15, fontWeight: 900 }} />,
  callIcon: <MdCall style={{ fontSize: 15, fontWeight: 900 }} />,
  // mailIcon: <MailIcon size={13} color={Colors?.Mblue} />,
  printIcon: <IoMdPrint size={13} color={Colors?.Mblue} />,
};

export const avatarColorFun = (index = 0) =>
  index >= 10 ? avatarColors[index % 10] : avatarColors[index];

export const htmlToText = (html = "") => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

export const CRMCustomScrollTable = ({
  datas,
  scrollRef,
  scrollHeight,
  children,
  ...props
}) => {
  return (
    <Grow in={true} style={{ transformOrigin: "0 0 0" }} timeout={1000}>
      <Div
        className="crmscrolltable"
        sx={{
          mb: 1,
          backgroundColor: "#52453317 !important",
          padding: "0px 30px 0px 30px !important",
          borderRadius: "5px !important",
        }}
      >
        <CustomScrollbarBox ref={scrollRef} scrollHeight={scrollHeight}>
          {children}
        </CustomScrollbarBox>
      </Div>
    </Grow>
  );
};

// export const CRMSeparateDateTime = (timestamp) => {
//     const dateFormat = localStorage.getItem('DateFormat');;

//     // Ensure timestamp is a string or handle Date objects
//     const correctedData = React.useMemo(() => {
//         if (!timestamp) return "";

//         return typeof timestamp === "string"
//             ? timestamp.slice(0, 10)
//             : timestamp instanceof Date
//                 ? timestamp.toISOString().slice(0, 10)
//                 : "";
//     }, [timestamp]);

//     // Memoize the formatted date value based on the date and date format
//     const formattedDate = React.useMemo(() => {
//         if (dateFormat && correctedData) {
//             try {
//                 return format(new Date(correctedData), dateFormat);
//             } catch (error) {
//                 console.error("Date formatting error:", error);
//                 return correctedData;
//             }
//         }
//         return correctedData;
//     }, [correctedData, dateFormat]);

//     const dateObject = React.useMemo(() => {
//         return typeof timestamp === "string" ? new Date(timestamp) : timestamp;
//     }, [timestamp]);

//     if (!timestamp) {
//         return "";
//     }

//     const timePart = dateObject.toLocaleTimeString("en-GB");
//     const dateTimeString = `${formattedDate} ${timePart}`;

//     return dateTimeString;
// };

export const CRMCustomLoader = () => {
  return (
    <JumboContentLayoutMain>
      <Div
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Div>
    </JumboContentLayoutMain>
  );
};

export const Customgrid = memo(
  ({ children, columnCount, staticColSpan = false }) => {
    // Calculate the column sizes for odd and even indexed children
    return (
      <Grid container spacing={2}>
        {React.Children.map(children, (child, index) => {
          let colSpan = child.props.colSpan;

          if (colSpan === undefined) {
            if (index % 2 === 0) {
              colSpan = columnCount === 4 ? 2 : 2.5;
            } else {
              colSpan = columnCount === 4 ? 4 : 9.5;
            }
          }

          // Override with staticColSpan if provided
          if (staticColSpan) {
            colSpan = columnCount;
          }
          return (
            <Grid item xs={12} md={colSpan} key={index}>
              {React.cloneElement(child)}
            </Grid>
          );
        })}
      </Grid>
    );
  },
);

export const AvatarCircle = ({
  fontSize = "10px",
  size = "25px",
  title = "",
  bgColor = Colors?.Mblue,
  boxShadow = "0px 0px 8px 0px #f9fafe",
  textColor = "white",
  textAlign = "center",
  fullTitle = false,
  label = "",
  labelSize = "12px",
  labelColor = Colors?.Mblue,
  subLabel = "",
  subLabelColor = "black",
  subLabelSize = "11px",
  gap = 0,
  image = false,
  onClick,
  marginTop,
}) => {
  const lightenColor = (color, percentage) => {
    const num = parseInt(color.slice(1), 16);
    const amt = Math.round(2.55 * percentage);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;

    return `rgba(${Math.min(R, 255)}, ${Math.min(G, 255)}, ${Math.min(
      B,
      255,
    )}, 0.5)`;
  };

  return (
    <>
      <Div onClick={onClick} sx={{ marginTop: marginTop }}>
        <FormControlLabel
          sx={{ m: 0, ml: 0.1 }}
          control={
            <Avatar
              src={image}
              sx={[
                AvatarFont,
                {
                  textAlign: textAlign,
                  background: bgColor,
                  width: size,
                  height: size,
                  color: textColor,
                  fontSize: fontSize,
                  justifyContent: textAlign,
                  // boxShadow: lightBoxShadow,
                  boxShadow: boxShadow,
                },
              ]}
            >
              {Boolean(title) && (
                <Typography
                  sx={[
                    {
                      fontSize: fontSize,
                      color: textColor,
                      textAlign: textAlign,
                      transform: Boolean(fullTitle)
                        ? "translateX(6px)"
                        : "translateX(0px)",
                    },
                  ]}
                >
                  {!Boolean(fullTitle)
                    ? title?.substring(0, 2)?.toUpperCase()
                    : title}
                </Typography>
              )}
            </Avatar>
          }
          label={
            label !== "" ? (
              <>
                <Typography
                  sx={{
                    color: labelColor,
                    fontSize: labelSize,
                    ml: 0.5,
                    mb: gap,
                  }}
                >
                  {label}
                </Typography>

                {Boolean(subLabel) && (
                  <Typography
                    sx={{
                      color: subLabelColor,
                      fontSize: subLabelSize,
                      ml: 0.5,
                      mt: gap,
                    }}
                  >
                    {subLabel}
                  </Typography>
                )}
              </>
            ) : (
              ""
            )
          }
        />
      </Div>
    </>
  );
};

export const getYears = (startYear = 2024) => {
  const currentYear = new Date().getFullYear();
  return Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => currentYear - i,
  );
};

export const getWeekNumber = () => {
  const currentDate = new Date();
  const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
  const pastDaysOfYear = (currentDate - startOfYear) / 86400000; // ms in a day
  return Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);
};

export const getLastWeekRange = () => {
  const today = new Date();
  const endDate = new Date(today); // Today
  const startDate = new Date(today);
  startDate.setDate(startDate.getDate() - 7); // 7 days ago

  // Format as YYYY-MM-DD (you can also use toISOString().split("T")[0])
  const formatDate = (date) => date.toISOString().split("T")[0];

  return {
    start_date: formatDate(startDate),
    end_date: formatDate(endDate),
  };
};

export const skipRequiredAsterisk = () => {
  return TENANTS_WITHOUT_REQUIRED_FIELD.includes(Tenantname?.toLowerCase());
};

// newly added on 22-02-2026 by ponkumar 
// its only for approve through application not for mail
export const returnMailToInitiator = async ({
  WorkflowName,
  updatedApprovals,
  requests,
}) => {
  const userId = parseInt(localStorage.getItem("EmployeeId"));
  console.log("updatedApprovals", updatedApprovals)
  try {
    const approveLength = updatedApprovals?.Approve?.length || 0;

    if (!approveLength) return; // no approval found

    const latestApproval = updatedApprovals?.Approve?.find((opt) => opt?.id == userId);

    const mailHTML = generateHRApprovalMail({
      workflowName: FirstLetterCaps(WorkflowName),
      latestApproval: latestApproval,
      requests: requests,
    });

    await axios.post(`${BASE_URL}/Felix/Approvalrejectmail/`, {
      MailId:
        requests?.Employee_Id?.Email_Id ||
        requests?.Employee_Id?.email ||
        requests?.Created_By?.Email_Id ||
        requests?.Created_By?.email ||
        "",

      mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,

      ApproverId: latestApproval?.id,

      mailhtml: mailHTML,
    });

    console.log("Mail sent to initiator");
  } catch (error) {
    console.error("Mail sending failed:", error);
  }
};

TableDataCount.propTypes = {
  count: PropTypes.number,
};

ReportTableHead.propTypes = {
  heads: PropTypes.array,
  colSpans: PropTypes.number,
};

CustomTooltip.propTypes = {
  value: PropTypes.string,
  realvalue: PropTypes.string,
  char: PropTypes.number,
};